import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { BasePage } from '../../base.page';
import { ContractInterface, GetContractUseCase, SetTransferUseCase, TransferInterface } from '../../../../core';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { Id, Transfer } from '../../../domain/data';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { AppConfig } from 'src/app/main/utils/app-config.service';

@Component({
    templateUrl: './test-transfer.component.html',
    styleUrls: ['./test-transfer.component.scss'],
})
export class TestTransferPage extends BasePage implements AfterViewInit, OnInit {
    private contract: ContractInterface;
    public transfer: TransferInterface;

    constructor(
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private router: Router,
        private setTransferUseCase: SetTransferUseCase
    ) {
        super(parentEvents);
    }

    ngOnInit(): void {
        this.getContract();
    }

    private getContract(): void {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.contract = transaction.data;
                this.transfer = this.contract.transfer || new Transfer(this.contract.encryptedCode as Id);
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    onSubmit() {
        this.setTransferUseCase.bind({ transfer: this.transfer }).subscribe((transaction) => {
            transaction.fold(
                () => this.router.navigateByUrl(MainRoutes.TEST_RATE),
                (throwable) =>
                    this.dialog.open(ErrorDialog, {
                        data: { text: throwable.message },
                    })
            );
        });
    }

    get minimumInitialContribution(): number {
        return AppConfig.settings.initialContribution?.min || 0;
    }

}
